import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { NoAuthGuard } from './auth/no-auth.guard';

const authModule = () => import('./auth/auth.module').then(x => x.AuthModule);
const LayoutModule = () => import('./layout/layout.module').then(x => x.LayoutModule);
const legalsModule = () => import('./pages/legals/legals.module').then(x => x.LegalsModule);
// Lazy: PublicLayoutComponent importa SharedComponensModule completo; importado eager lo mete al bundle inicial
const publicLayout = () => import('./shared/components/public-layout/public-layout.component').then(x => x.PublicLayoutComponent);

const routes: Routes = [
  { path: 'er', loadChildren: LayoutModule, canActivate: [authGuard] },
  // Páginas legales públicas (links del footer en el login); sin guard de sesión
  { path: 'legals', loadComponent: publicLayout, loadChildren: legalsModule },
  { path: '', loadChildren: authModule,  canActivate: [NoAuthGuard] },
  { path: '**', redirectTo: '/er' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
